import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { Utils } from "../../common/views/Utils";
import { EditPictureModel, PictureModel, UploadPictureModel } from "../models/PictureModel";

export interface IPictureService {
    create: (ownerId: any, model: FormData) => JQueryPromise<any>;
    edit: (ownerId: any, model: EditPictureModel) => JQueryPromise<any>;
    editList: (ownerId: any, pictures: EditPictureModel[]) => JQueryPromise<any>;
    delete: (ownerId: any, id: number) => JQueryPromise<any>;
    getList: (ownerId: any) => JQueryPromise<any>;
}

export function usePictureVM(ownerId: any, isReadOnly: boolean, service: IPictureService) {
    const [pictures, setPictures] = useState<PictureModel[]>([]);
    const [editPictures, setEditPictures] = useState<EditPictureModel[]>([]);
    const [uploadPictures, setUploadPictures] = useState<UploadPictureModel[]>([]);

    const [selectedPicture, setSelectedPicture] = useState<PictureModel | undefined>(undefined);
    const [listHash, setListHash] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [showEntry, setShowEntry] = useState<boolean>(false);
    const [showAdd, setShowAdd] = useState<boolean>(false);
    const [showEdit, setShowEdit] = useState<boolean>(false);

    const getList = () => {
        setPictures([]);
        setEditPictures([]);

        DataUtils.onRequest(service.getList(ownerId), onGetListResult);
    }

    const onGetListResult = (result: IDataResult) => {
        if (result.status === ResponseStatus.success) {
            let pictures = result.data as PictureModel[];
            let selectedPicture: PictureModel | undefined = undefined;

            if (pictures.length > 0) {
                selectedPicture = pictures[0];
            }

            setPictures(pictures);
            setEditPictures(pictures);
            setSelectedPicture(selectedPicture);
            setListHash(Utils.getRandomKey());
        }
    }

    const createList = (prefix: string) => {
        if (uploadPictures.length === 0) {
            alert("There is no file selected.");
            return;
        }

        var formData = buildFormData(prefix);
        let request = service.create(ownerId, formData);

        setLoading(true);
        DataUtils.onRequest(request, onCreateListResult);
    }

    const buildFormData = (prefix: string): FormData => {
        var requestForm = new FormData();

        for (let i = 0; i < uploadPictures.length; i++) {
            const picture = uploadPictures[i];
            const prefixIndex = prefix + "[" + i + "]";
            Utils.buildFormDataProperties(requestForm, picture, [], prefixIndex);
        }

        return requestForm;
    }

    const onCreateListResult = (response: IDataResult) => {
        if (!response.errorMessages) {
            response.errorMessages = {};
        }

        if (response.status === ResponseStatus.success) {
            setShowAdd(false)
        }

        setLoading(false);
        //this.setState({ ...(response as IResult), isSubmitting: false });
    }

    const editList = () => {
        if (editPictures.length === 0) {
            alert("There is no file selected.");
            return;
        }

        setLoading(true);

        const request = service.editList(ownerId, editPictures);
        DataUtils.onRequest(request, onEditListResult);
    }

    const onEditListResult = (response: IDataResult) => {
        if (!response.errorMessages) {
            response.errorMessages = {};
        }

        if (response.status === ResponseStatus.success) {
            setShowEdit(false);
        }

        setLoading(false);
        //this.setState({ ...(response as IResult), isSubmitting: false });
    }

    const updateUploadPictureField = <K extends keyof UploadPictureModel>(
        id: number, field: K, value: UploadPictureModel[K]
    ) => {
        setUploadPictures(prev =>
            prev.map(item => item.id === id ? { ...item, [field]: value } : item)
        );
    };

    const updateEditPictureField = <K extends keyof EditPictureModel>(
        id: number, field: K, value: EditPictureModel[K]
    ) => {
        setEditPictures(prev =>
            prev.map(item => item.id === id ? { ...item, [field]: value } : item)
        );
    };

    const del = () => {
        const onResult = (result: IDataResult) => {
            if (result.status === ResponseStatus.success) {
                getList();
            }
        }

        const msg = "Are you sure to delete the selected picture?";

        if (selectedPicture && window.confirm(msg)) {
            const request = service.delete(ownerId, selectedPicture.id);
            DataUtils.onRequest(request, onResult);
        }
    }

    return {
        pictures,
        setPictures,

        uploadPictures,
        setUploadPictures,
        updateUploadPictureField,
        updateEditPictureField,

        editPictures,
        setEditPictures,

        selectedPicture,
        setSelectedPicture,

        listHash,
        setListHash,
        loading,
        setLoading,
        showEntry,
        setShowEntry,
        showAdd,
        setShowAdd,
        showEdit,
        setShowEdit,

        createList,
        editList,
        del,
        getList
    }
}